import { pipe } from 'ramda';

import {
  isViewed as isViewedCluster,
  isAvailable as isViewedClustersAvailable,
} from '../../../browser/utils/viewedClusters';
import { TMapBounds } from '../../types/mapBounds';
import { IGetClustersForMapResponse } from '../../repositories/search-engine/v1/get-clusters-for-map';
import { queryStringWithMapBounds, isCenterZoomBounds } from '../../utils/mapBounds';

export function prepareClusters(data: IGetClustersForMapResponse, mapBounds: TMapBounds): IGetClustersForMapResponse {
  return pipe(prepareQueryStrings, prepareViewedOffers)(data, mapBounds);
}

function prepareQueryStrings(data: IGetClustersForMapResponse, mapBounds: TMapBounds): IGetClustersForMapResponse {
  if (!isCenterZoomBounds(mapBounds)) {
    return data;
  }

  return {
    ...data,
    queryString: queryStringWithMapBounds(data.queryString, mapBounds),
    extendedQueryString: queryStringWithMapBounds(data.extendedQueryString || '', mapBounds),
  };
}

function prepareViewedOffers(data: IGetClustersForMapResponse): IGetClustersForMapResponse {
  if (!isViewedClustersAvailable()) {
    return data;
  }

  return {
    ...data,
    filtered: data.filtered?.map(cluster => ({
      ...cluster,
      isViewed: cluster.isViewed || isViewedCluster(cluster.geohash),
    })),
    extended: data.extended?.map(cluster => ({
      ...cluster,
      isViewed: cluster.isViewed || isViewedCluster(cluster.geohash),
    })),
  };
}
